import { Button, Title } from '@qonsoll/react-design'
import { Form, Input } from 'antd'
import { KEYS, MAX_LENGTH_FIELD } from '__constants__'

import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const SubadminSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group, isEdit } =
    props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Subadmin')}
        </Title>
      )}
      <Form.Item
        label={t('First name')}
        name={[...group, 'firstName']}
        rules={[
          {
            required: true,
            message: t('Please enter first name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('first name is too long!') }
        ]}>
        <Input placeholder={t('Please enter first name')} />
      </Form.Item>
      <Form.Item
        label={t('Last name')}
        name={[...group, 'lastName']}
        rules={[
          {
            required: true,
            message: t('Please enter last name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('last name is too long!') }
        ]}>
        <Input placeholder={t('Please enter last name')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name={[...group, 'email']}
        rules={[
          {
            type: 'email',
            message: t('The input is not valid E-mail!')
          },
          {
            required: true,
            message: t('Please enter email!')
          },
          { max: MAX_LENGTH_FIELD, message: t('email is too long!') }
        ]}>
        <Input placeholder={t('Please enter email')} disabled={isEdit} />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Subadmin')}
        </Title>
      )}
      <Form.Item
        label={t('First name')}
        name="firstName"
        rules={[
          {
            required: true,
            message: t('Please enter first name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('first name is too long!') }
        ]}>
        <Input placeholder={t('Please enter first name')} />
      </Form.Item>
      <Form.Item
        label={t('Last name')}
        name="lastName"
        rules={[
          {
            required: true,
            message: t('Please enter last name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('last name is too long!') }
        ]}>
        <Input placeholder={t('Please enter last name')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name="email"
        rules={[
          {
            type: 'email',
            message: t('The input is not valid E-mail!')
          },
          {
            required: true,
            message: t('Please enter email!')
          },
          { max: MAX_LENGTH_FIELD, message: t('email is too long!') }
        ]}>
        <Input placeholder={t('Please enter email')} disabled={isEdit} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Add')}
          </Button>
        </>
      )}
    </Form>
  )
}

SubadminSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array,
  isEdit: PropTypes.bool
}

export default SubadminSimpleForm
